module.exports = __webpack_public_path__ + "img/Pizza-Hut_logo.c5e92bec.svg";